import { httpRequest } from "../../../../utils/HttpRequest";
import { IOrganRemove, IOrganSearch, IOrganUpdate, IOrganInsert, IOrganDetail, IOrganParams, IOrganDisable } from "./organizationTypes"
import { IPage } from "../../../../types/FmsTypes";
import { trasDsToTreeData } from "../dict/dictModel";
import { getVrmBaseRequestUrl } from "@src/utils/constants";

class OrganService {
    async page(params: IOrganSearch) {
        const apiUrl = "/base/org/page"
        return await httpRequest.post<IPage<IOrganDetail>>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() })
    }
    async allTree(params: any) {
        const apiUrl = "/base/org/allTree";
        params.sourceApp = "vrm"
        params.branchList = ["main", "fms"];
        return await httpRequest.post<any>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() })
    }
    async insert(params: IOrganInsert) {
        const apiUrl = "/base/org/insertLocal"
        return await httpRequest.post<boolean>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() })
    }
    async update(params: IOrganUpdate) {
        const apiUrl = "/base/org/updateLocal"
        return await httpRequest.post<boolean>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() })
    }
    async remove(params: IOrganRemove) {
        const apiUrl = "/base/org/remove"
        return await httpRequest.post<boolean>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() })
    }
    async disable(params: IOrganDisable) {
        const apiUrl = "/base/org/disable"
        return await httpRequest.post<boolean>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() })
    }
    async orgTreeDs(params: any) {
        let { retData } = await this.allTree(params);
        // retData.map(el=>({
        //     label:el.name,
        //     value:el.code,
        //     children:[]
        // }))
        let treeData = trasDsToTreeData(retData, "code", "name");
        return treeData;
    }
}
const organService = new OrganService()
export {
    organService
}